<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app, body, html{
  padding:0;
  margin:0;
  height:100%;
  overflow: hidden;
}
#app::-webkit-scrollbar{
  display: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.createDataSetMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45); /* 背景变暗 */
  z-index: 99999; /* 比页面高 */
}

</style>



// WEBPACK FOOTER //
// src/App.vue